const { showError, showNotifikasi } = require('../../libs/helper');
var qs = require('qs');

module.exports = {
    getDetail: (g, params) => {
        let result = g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/laporan/list',
            method: 'post',
            data: qs.stringify(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            console.log(err)
        })
        return result;
    },
    uploadDokumen: async (g, data) => {
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/laporan/submit',
            method: 'post',
            data,
        }).then(res => {
            return res.data;
        }).catch(err => {
            showError(g, err, `Error Submit Form`)
            return err;
        })
        return result;
    },
}